const formatDownloadFileName = (responseFile: any): string => {
  const fileDeposition = responseFile.headers.get('content-disposition');
  return fileDeposition.split(';')[1].split('=')[1].trim().replace(/"/g, '');
};

export default formatDownloadFileName;
